import Api from "../api";
import {
  AffiliateApplication,
  CreateAffilicateApplicationPayload,
} from "./affiliate-application.type";

const MODULE = "affiliate-applications";
const API_VERSION = "v1";

const create = async (payload: CreateAffilicateApplicationPayload) => {
  try {
    const res = await Api<DetailResponse<AffiliateApplication>>({
      url: `/${API_VERSION}/${MODULE}`,
      method: "POST",
      data: payload,
    });

    return res;
  } catch (error: any) {
    const errorMessage = error.response.data?.error?.message;
    console.log("🚀 > create > errorMessage:", errorMessage);
    throw new Error(errorMessage);
  }
};

const AffiliateApplicationApi = {
  create,
};

export default AffiliateApplicationApi;
